export function WebsocketHandler(gudhub, message) {
    switch (message.api) {
        case "/items/update":
            console.log("/items/update - ", message);
            gudhub.itemProcessor.updateItemsInStorage(
                message.app_id,
                message.response
            );
            break;
        case "/items/add":
            console.log("/items/add - ", message);
            gudhub.itemProcessor.addItemsToStorage(message.app_id, message.response);
            break;
        case "/items/delete":
            console.log("/items/delete - ", message);
            gudhub.itemProcessor.deleteItemsFromStorage(
                message.app_id,
                message.response
            );
            break;
        case "/app/update":
            console.log("/app/update - ", message);
            gudhub.appProcessor.updateAppFieldsAndViews(message.response);
            break;
        case "/file/delete":
            console.log("file/delete - ", message);
            gudhub.fileManager.deleteFileFromStorage(
                message.response.file_id,
                message.app_id
            );
            break;
        case "/file/upload":
            console.log("file/upload - ", message);
            gudhub.fileManager.addFileToStorage(message.app_id, message.response);
            break;
        case "/file/formupload": //I'm not shure if we are using it (probably in contact form)
            console.log("file/formupload - ", message);
            break;
        case "/file/update": //I'm not shure if we are using it (probably in contact form)
            gudhub.fileManager.updateFileInStorage(
                message.response.file_id,
                message.response.app_id,
                message.response
            );
            console.log("file/update - ", message);
            break;
        case "/new/file/duplicate": //I'm not shure if we are using it (probably in contact form)
            gudhub.fileManager.addFilesToStorage(message.app_id, message.response);
            console.log("new/file/duplicate - ", message);
            break;
        case '/api/new/document/insert-one':
            gudhub.documentManager.emitDocumentInsert(message.response);
            console.log('/api/new/document/insert-one - ', message);
            break;
        case '/ws/emit-to-user':
            console.log('/ws/emit-to-user - ', message);
            break;
        case '/ws/broadcast-to-app-subscribers':
            console.log('/ws/broadcast-to-app-subscribers - ', message);
            const response = JSON.parse(message.response);
            if(!response.data_type) return;
            gudhub.ghconstructor.getInstance(response.data_type).then(instance => {
                instance.onMessage(message.app_id, message.user_id, response);
            });
            break;
        default:
            console.warn("WEBSOCKETS is not process this API:", message.api);
    }
}